import { useMutation } from 'react-query';
import { BASE_URL } from '../configs/config';

interface PrinterStatusParams {
  order_id: string;
  print_message: string;
  type: string;
}

const useLogPrinterStatus = () => {
  return useMutation(async ({ order_id, print_message, type }: PrinterStatusParams) => {
    if (!print_message || !type) {
      throw new Error('Missing required fields');
    }

    const response = await fetch(`${BASE_URL}logPrinterStatus`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ order_id, print_message, type }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.error || 'Failed to log printer status ');
    }

    return response.json();
  });
};

export default useLogPrinterStatus;
